import { render } from "./accountManagement.vue?vue&type=template&id=0bbd10b1"
import script from "./accountManagement.vue?vue&type=script&lang=js"
export * from "./accountManagement.vue?vue&type=script&lang=js"

import "./accountManagement.vue?vue&type=style&index=0&id=0bbd10b1&scope=true&lang=less"

import exportComponent from "D:\\web\\dmsm\\dmsm-pages\\cloud\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__